import React from 'react';
import async from 'async';
import toastr from 'toastr';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';

import FitmentLogic from '../../Logic/Fitment';
import Database from '../../Logic/Database';
import ClaimStatus from '../common/ClaimStatus/ClaimStatus';
import TimeUpdateModal from './TimeUpdateModal';
import CurrentLocationModal from './CurrentLocationModal';

import './Fitment.css';

class Fitment extends React.Component {
  constructor(props) {
    super(props);

    this.confirmAddress = this.confirmAddress.bind(this);

    this.state = {
      fitment: {},
    };
  }

  componentDidMount() {
    this.fetchFitmentDetails();
  }

  fitmentScheduledForToday(fitmentDateString) {
    const fitmentDate = new Date(fitmentDateString);
    const today = new Date();

    return fitmentDate.getFullYear() >= today.getFullYear()
      && fitmentDate.getMonth() >= today.getMonth()
      && fitmentDate.getDate() > today.getDate();
  }

  fetchFitmentDetails() {
    async.waterfall(
      [
        FitmentLogic.FetchFitmentDetails,
        Database.WriteFitment,
        Database.FetchFitment,
      ],
      (error, fitment) => {
        if (error) {
          toastr.error(
            `Something went wrong and we were unable to fetch the fitment's details. Error: ${error.message}`,
            'Oops',
          );
        } else {
          this.setState({ fitment });
        }
      },
    );
  }

  confirmAddress() {
    async.waterfall(
      [
        Database.ConfirmAddress,
        FitmentLogic.ConfirmAddress,
        Database.FetchFitment,
      ],
      async (error, fitment) => {
        if (error) {
          toastr.error(
            `Something went wrong and we were unable to fetch the fitment's details. Error: ${error.message}`,
            'Oops',
          );
        } else {
          this.props.confirmAddress(true);
          this.setState({ fitment });

          await Swal.fire({
            title: 'Confirm Details',
            html: 'Fitment address successfully confirmed. Please confirm vehicle.',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        }
      },
    );
  }

  async UpdateTime(newTime) {
    try {
      const success = await FitmentLogic.UpdateFitmentTime(newTime);
      if (!success) throw new Error('Unable to update fitment time.');
      toastr.success('A time update request has been sent to the agent handling this claim.', 'Success');
    } catch (error) {
      toastr.error(error.message, 'Failed to update fitment time.');
    }
  }

  async SendLocation(newAddress, Lat, Lng) {
    try {
      const success1 = await FitmentLogic.UpdateLocation(newAddress, Lat, Lng);
      const success2 = await FitmentLogic.UpdateFitmentAddress(newAddress);

      if (!success1 || !success2) throw new Error('Unable to update fitment location.');

      toastr.success(
        'Please note. Your request reflects a preferred fitment location change and will only be confirmed once one of our representatives contact you.',
        'Success',
      );
    } catch (error) {
      toastr.error(error.message, 'Failed to update fitment location.');
    }
  }

  renderButtons() {
    const { fitment } = this.state;

    if (!fitment.Confirmed) {
      return (
        <div style={{ marginTop: '10px' }} className="text-center row">
          <div className="col-sm-6">
            <button
              type="button"
              className="btn btn-success col-xs-12"
              onClick={this.confirmAddress}
            >
              Confirm Address
            </button>
          </div>
          <div className="col-sm-6">
            <button
              type="button"
              className="btn btn-success col-xs-12"
              data-toggle="modal"
              data-target="#currentLocationModal"
            >
              Update Fitment Location
            </button>
          </div>
        </div>
      );
    }

    if (!this.fitmentScheduledForToday(fitment.FitmentDate)) {
      return (
        <div>
          <div style={{ marginTop: '10px' }} className="col-sm-6 col-sm-offset-3">
            <button
              type="button"
              className="btn btn-success col-xs-12"
              data-toggle="modal"
              data-target="#currentLocationModal"
            >
              Update Fitment Location
            </button>
          </div>
          <div style={{ marginTop: '10px' }} className="col-sm-6 col-sm-offset-3">
            <button
              type="button"
              className="btn btn-success col-xs-12"
              data-toggle="modal"
              data-target="#timeUpdateModal"
            >
              Update Time
            </button>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div style={{ marginTop: '10px' }} className="col-sm-6 col-sm-offset-3">
          <button
            type="button"
            className="btn btn-success col-xs-12"
            data-toggle="modal"
            data-target="#currentLocationModal"
          >
            Share My Location
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { fitment } = this.state;

    return (
      <div>
        <div className="row">
          <ClaimStatus />
        </div>
        <div className="row grey-cell">
          {fitment && (
            <div id="fitment-details col-xs-12">
              <div className="col-xs-12">
                <div className="row fitment-header">
                  <div className="col-xs-6 text-right">Fitment Address</div>
                  <div
                    style={{ textTransform: 'capitalize' }}
                    className={`col-xs-6 text-left ${fitment.Confirmed ? 'confirmed' : 'not-confirmed'}`}
                  >
                    <div className="row">
                      <div className="col-xs-12">
                        <FontAwesome name={fitment.Confirmed ? 'check' : 'exclamation'} />
                        {' '}
                        {fitment.Confirmed ? 'Confirmed' : 'Not Confirmed'}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12">
                    <div className="text-left row">
                      <div className="col-xs-6 text-right">
                        <b>Scheduled For:</b>
                      </div>
                      <div className="col-xs-6">{fitment.FitmentDate || 'Not Scheduled'}</div>
                    </div>

                    <div className="text-left row">
                      <div className="col-xs-6 text-right">
                        <b>Address:</b>
                      </div>
                      <div className="col-xs-6" role="button" tabIndex={0}>
                        {fitment.Address
                          ? fitment.Address.split(', ').map((item) => (
                            <span key={item}>
                              {item}
                              <br />
                            </span>
                          ))
                          : ''}
                      </div>
                    </div>

                    <div className="text-left row">
                      <div className="col-xs-6 text-right">
                        <b>Special Instructions:</b>
                      </div>
                      <div className="col-xs-6">
                        {!_.isNull(fitment.Instructions) ? fitment.Instructions : 'None'}
                      </div>
                    </div>

                    {this.renderButtons()}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <TimeUpdateModal UpdateTime={(time) => this.UpdateTime(time)} />
        <CurrentLocationModal
          SendLocation={(addr, lat, lng) => this.SendLocation(addr, lat, lng)}
        />
      </div>
    );
  }
}

Fitment.propTypes = {
  confirmAddress: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  confirmAddress: (confirmed) => {
    dispatch({ type: 'CONFIRM_ADDRESS', value: confirmed });
  },
});

export default connect(null, mapDispatchToProps)(Fitment);
